// components/Services.js
import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: "企业环保咨询",
      icon: "📝",
      description: "提供环保政策解读、环评咨询、排污许可申报、环保合规审计等专业咨询服务，帮助企业规避环境风险，实现合规运营。",
      features: ["环保政策咨询", "环评报告编制", "排污许可证申报", "环保合规审计", "应急预案编制"]
    },
    {
      title: "环保设备安装运维",
      icon: "🔧",
      description: "专业团队提供环保设备的安装、调试、维护和升级服务，确保设备高效稳定运行，延长使用寿命。",
      features: ["设备安装调试", "定期维护保养", "故障诊断维修", "性能优化升级", "备件供应"]
    },
    {
      title: "污染源在线监测",
      icon: "📊",
      description: "提供污染源在线监测系统的安装、运维和数据管理服务，确保监测数据准确可靠，满足环保部门监管要求。",
      features: ["系统设计安装", "设备运维管理", "数据采集分析", "联网对接服务", "数据异常处理"]
    },
    {
      title: "污水处理站运维",
      icon: "💧",
      description: "专业团队负责污水处理站的日常运营、维护和管理，确保出水水质稳定达标，降低运营成本。",
      features: ["日常运行管理", "水质监测分析", "设备维护保养", "污泥处理处置", "运行报告编制"]
    },
    {
      title: "环保软件开发",
      icon: "💻",
      description: "根据企业需求定制开发环保管理软件，实现环保数据智能化管理，提高工作效率和管理水平。",
      features: ["环保管理系统", "在线监测平台", "移动巡检系统", "数据分析报表", "定制化开发"]
    },
    {
      title: "安防",
      icon: "🔒",
      title: "安防系统集成",
      description: "集成多种安防设备，打造全方位安全防护体系。",
      features: [
        "门禁系统",
        "报警系统",
        "访客管理",
        "智能联动"
      ]
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2>我们的服务</h2>
        <p className="services-intro">我们提供全方位的环保技术服务，帮助企业解决环保难题，实现可持续发展</p>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-features">
                <h4>服务内容：</h4>
                <ul>
                  {service.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;